import type { StyleRule } from '@archipro-design/aria';
import { hex2rgba } from '~/utils/colorHelper';

/** Matches the Aria Button size={20} icon footprint (pxToRem(20) = 1.25rem). */
const EDIT_MODE_ICON_SIZE = '1.25rem';

/**
 * A close, light shadow: the buttons now sit on the island's frosted panel, which
 * supplies the elevation. The former wide drop shadow was tuned for buttons
 * floating directly on the page and pooled visibly inside the panel.
 */
export const ActionButton: StyleRule = ({ theme }) => ({
    boxShadow: `0px 2px 8px 0px ${hex2rgba(
        theme.siteVariables.colors.primitive.black,
        0.1,
    )}`,
});

/** Hides the pencil while it still reserves layout space under Aria's absolute loader. */
export const ActionButtonHiddenIcon: StyleRule = () => ({
    opacity: 0,
});

/**
 * Aria's loader is absolutely positioned; force its icon to the same size={20} box as the pencil.
 */
export const ActionButtonNavigating: StyleRule = () => ({
    '& .ui-button__loader .ui-icon': {
        width: EDIT_MODE_ICON_SIZE,
        height: EDIT_MODE_ICON_SIZE,
    },
    '& .ui-button__loader .ui-icon svg': {
        width: EDIT_MODE_ICON_SIZE,
        height: EDIT_MODE_ICON_SIZE,
    },
});

export const Copied: StyleRule = ({ theme }) => ({
    fill: theme.siteVariables.colors.success['200'],
});
